export const SOCIAL_PLATFORMS = {
  X: 'x',
  THREADS: 'threads',
  FACEBOOK: 'facebook',
  OTHERS: 'others',
} as const

export type SocialPlatform = (typeof SOCIAL_PLATFORMS)[keyof typeof SOCIAL_PLATFORMS]

/**
 * Centralized list of supported platforms for UI elements (forms, filters, etc.)
 */
export const PLATFORM_OPTIONS = [
  SOCIAL_PLATFORMS.X,
  SOCIAL_PLATFORMS.THREADS,
  SOCIAL_PLATFORMS.FACEBOOK,
  SOCIAL_PLATFORMS.OTHERS,
] as const

/**
 * Common normalization logic to handle variations like 'twitter' -> 'x'
 */
export function normalizePlatform(platform: string | undefined): SocialPlatform {
  if (!platform) return SOCIAL_PLATFORMS.OTHERS

  const p = platform.toLowerCase().trim()
  if (p === 'x' || p === 'twitter') return SOCIAL_PLATFORMS.X
  if (p === 'facebook') return SOCIAL_PLATFORMS.FACEBOOK
  if (p === 'threads') return SOCIAL_PLATFORMS.THREADS

  return SOCIAL_PLATFORMS.OTHERS
}
